
import Footer from '../../components/feature/Footer';
import Header from '../../components/feature/Header';
import WaiverSection from './components/WaiverSection';




function Waiver() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <WaiverSection />
      </main>
      <Footer />
    </div>
  );
}

export default Waiver;